"use client";
import { jsxs as r, jsx as a } from "react/jsx-runtime";
import { useElementSize as m, Paper as D, Group as c, Heading as H, Icon as d, ScrollArea as v, Paragraph as n, Accordion as A, Html as z } from "@ingeniorforeningen/figurine-core";
import { forwardRef as P, useState as j } from "react";
import { S as e } from "../../../../Schema.module-DGiUhHO2.js";
const p = P(
  (h, u) => {
    const { header: f, tableData: l, variant: g } = h, [x, N] = j({ x: 0, y: 0 }), { ref: b, width: y } = m(), { ref: S, width: w } = m(), C = x.x <= 5 && Math.ceil(y) < w, o = {
      "--passed-no-of-titles": l?.titles?.length
    };
    return /* @__PURE__ */ r(D, { p: "xl", ref: u, children: [
      /* @__PURE__ */ r(
        c,
        {
          align: "center",
          justify: "space-between",
          wrap: "nowrap",
          pb: "xl",
          pt: "xs",
          className: e.group,
          children: [
            /* @__PURE__ */ a(H, { type: "h2", text: f.title, className: e.header }),
            C && /* @__PURE__ */ r(c, { wrap: "nowrap", spacing: 0, children: [
              /* @__PURE__ */ a(d, { name: "HandFinger", size: "lg", className: e.hand }),
              /* @__PURE__ */ a(d, { color: "dark", name: "ArrowLeft", size: "sm", className: e.arrow })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ r(
        v,
        {
          type: "auto",
          onScrollPositionChange: N,
          scrollbarSize: 4,
          ref: b,
          className: e.scrollArea,
          classNames: {
            scrollbar: e.scrollBar,
            thumb: e.scrollThumb
          },
          children: [
            l.titles?.length && /* @__PURE__ */ r(
              c,
              {
                wrap: "nowrap",
                spacing: 0,
                ref: S,
                className: e.tableHeader,
                style: o,
                children: [
                  l.titles.map((t, s) => /* @__PURE__ */ a(
                    n,
                    {
                      variant: "light",
                      strong: !0,
                      p: "md",
                      className: s === 0 ? e.invisibleHeader : e.headContent,
                      text: t,
                      condensed: !0
                    },
                    t + s
                  )),
                  /* @__PURE__ */ a(
                    n,
                    {
                      strong: !0,
                      p: "md",
                      variant: "light",
                      className: e.firstHead,
                      text: l.titles[0],
                      condensed: !0
                    }
                  ),
                  /* @__PURE__ */ a(
                    n,
                    {
                      strong: !0,
                      p: "md",
                      className: e.whiteBoxHeader,
                      text: l.titles[0],
                      condensed: !0
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ a(
              A,
              {
                className: e.accordion,
                style: o,
                mod: { variant: g },
                items: l.data.map((t) => ({
                  icon: t.icon,
                  value: t.title,
                  disabled: !t.accordionData,
                  className: e.item,
                  content: t.accordionData && /* @__PURE__ */ a(z, { html: t.accordionData, className: e.rowDescription }),
                  label: /* @__PURE__ */ r(c, { align: "center", wrap: "nowrap", spacing: 0, children: [
                    /* @__PURE__ */ a(
                      n,
                      {
                        className: e.firstCol,
                        text: t.title,
                        condensed: !0,
                        style: o
                      }
                    ),
                    t.values?.length ? t.values.map(
                      (s, i) => typeof s == "boolean" ? s === !0 ? /* @__PURE__ */ a(
                        "div",
                        {
                          className: e.tableContents,
                          children: /* @__PURE__ */ a(
                            d,
                            {
                              name: "Circle",
                              size: "xs",
                              radius: "xl",
                              className: e.icon
                            }
                          )
                        },
                        `schema-default-${s}${i}`
                      ) : /* @__PURE__ */ a(
                        n,
                        {
                          px: "xs",
                          className: e.tableContents,
                          text: "",
                          condensed: !0
                        },
                        i
                      ) : /* @__PURE__ */ a(
                        n,
                        {
                          align: "center",
                          variant: "primary",
                          px: "xs",
                          lineClamp: 3,
                          className: e.tableContents,
                          text: s,
                          condensed: !0
                        },
                        i
                      )
                    ) : null
                  ] }, t.title)
                }))
              }
            )
          ]
        }
      )
    ] });
  }
);
p.displayName = "SchemaDefault";
const k = p;
export {
  p as _SchemaDefault,
  k as default
};
